import { Controller } from "@hotwired/stimulus"
import Chart from "chart.js"

// Connects to data-controller="online-activity-chart"
export default class extends Controller {
  static values = {
    datasets: Array,
    labels: Array
  }

  connect() {
    this.renderChart()
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
    }
  }

  renderChart() {
    const canvas = this.element.querySelector("canvas")
    if (!canvas) return

    const ctx = canvas.getContext("2d")

    this.chart = new Chart(ctx, {
      type: "line",
      data: {
        labels: this.labelsValue,
        datasets: this.datasetsValue,
      },
      options: {
        animation: {
          duration: 500,
          easing: "easeOutQuart",
        },
        maintainAspectRatio: false,
        tooltips: {
          mode: "index",
          intersect: false,
        },
        hover: {
          mode: "nearest",
          intersect: true,
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                precision: 0,
              },
            },
          ],
        },
      },
    })
  }
}
